import { Dispatch, SetStateAction } from 'react';
import FilterRadioButton from '../../../../../components/FilterRadioButtons';
import MyModal from '../../../../../components/Modal';
import { PeriodType } from '../../types';
import { MonthsGrid } from './styles';

interface IChangePeriodModal {
  changePeriodModalShow: boolean;
  setChangePeriodModalShow: Dispatch<SetStateAction<boolean>>;
  periodBeingSelected?: PeriodType;
  setPeriodBeingSelected?: Dispatch<SetStateAction<PeriodType>>;
  setSelectedPeriod?: Dispatch<SetStateAction<PeriodType>>;
  periodBeingSelectedAutImp?: PeriodType;
  setPeriodBeingSelectedAutImp?: Dispatch<SetStateAction<PeriodType>>;
  setSelectedPeriodAutImp?: Dispatch<SetStateAction<PeriodType>>;
  customAction?: (month?: number, year?: number) => Promise<void>;
}

export default function ChangePeriodModal({
  changePeriodModalShow,
  setChangePeriodModalShow,
  periodBeingSelected,
  setPeriodBeingSelected,
  setSelectedPeriod,
  customAction = undefined,
  periodBeingSelectedAutImp,
  setPeriodBeingSelectedAutImp,
  setSelectedPeriodAutImp,
}: IChangePeriodModal) {
  const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  const monthsMap: { [key: number]: string } = {
    1: 'Janeiro',
    2: 'Fevereiro',
    3: 'Março',
    4: 'Abril',
    5: 'Maio',
    6: 'Junho',
    7: 'Julho',
    8: 'Agosto',
    9: 'Setembro',
    10: 'Outubro',
    11: 'Novembro',
    12: 'Dezembro',
  };

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1;

  const periodBeingSelectedToUse = periodBeingSelectedAutImp || periodBeingSelected;
  const setPeriodBeingSelectedToUse = setPeriodBeingSelectedAutImp || setPeriodBeingSelected;
  const setSelectedPeriodToUse = setSelectedPeriodAutImp || setSelectedPeriod;

  if (!periodBeingSelectedToUse || !setPeriodBeingSelectedToUse || !setSelectedPeriodToUse) return;

  return (
    <MyModal
      show={changePeriodModalShow}
      type="action"
      title="Alterar Período"
      centeredBody
      modalBody={(
        <div className="modal-body-centered">
          <div className="year-selection">
            <FilterRadioButton
              onClick={() => {
                setPeriodBeingSelectedToUse((prevState) => ({
                  ...prevState,
                  year: Number(currentYear) - 2
                }));
              }}
              selected={periodBeingSelectedToUse.year == Number(currentYear) - 2}
            >
              {String(Number(currentYear) - 2)}
            </FilterRadioButton>
            <FilterRadioButton
              onClick={() => {
                setPeriodBeingSelectedToUse((prevState) => ({
                  ...prevState,
                  year: Number(currentYear) - 1
                }));
              }}
              selected={periodBeingSelectedToUse.year == Number(currentYear) - 1}
            >
              {String(Number(currentYear) - 1)}
            </FilterRadioButton>
            <FilterRadioButton
              onClick={() => {
                setPeriodBeingSelectedToUse((prevState) => ({
                  ...prevState,
                  year: Number(currentYear)
                }));
              }}
              selected={periodBeingSelectedToUse.year == Number(currentYear)}
            >
              {currentYear}
            </FilterRadioButton>
          </div>
          <MonthsGrid>
            {months.map((month) => (
              <FilterRadioButton
                key={month}
                onClick={() => setPeriodBeingSelectedToUse((prevState) => ({
                  ...prevState,
                  month,
                }))}
                selected={month == periodBeingSelectedToUse.month}
                invisible={currentYear === periodBeingSelectedToUse.year && month > currentMonth}
              >
                {monthsMap[month]}
              </FilterRadioButton>
            ))}
          </MonthsGrid>
        </div>
      )}
      size="lg"
      onAction={() => {
        if (customAction) {
          customAction(periodBeingSelectedToUse.month, periodBeingSelectedToUse.year);
        } else {
          setSelectedPeriodToUse(periodBeingSelectedToUse);
        }
        setChangePeriodModalShow(false);
      }}
      onClose={() => setChangePeriodModalShow(false)}
      actionButtonLabel="Alterar Período"
      closeButtonLabel="Cancelar"
    />
  );
}
